// extracted by mini-css-extract-plugin
export default {"addProductButton":"ProductPickerModal_addProductButton__YYWSB","searchInput":"ProductPickerModal_searchInput__FVQHr"};